import * as React from 'react';
import { useState } from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { Link } from 'stile-shared/src/components/2024/common/Link';
import { ResourceAccessBlock } from 'stile-shared/src/components/2024/layout/ResourceAccessBlock/ResourceAccessBlock';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

import { GapApplicationFormAu } from 'components/common/GapApplicationFormAu';

const GAP_OVERVIEW_PDF = 'https://stileapp.com/go/GAPoverview';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Stile's Grants and Assistance Program"
      description="Apply for financial assistance to support your school's Stile subscription."
      slug={props.location.pathname}
      uniqueToLocale
    >
      {/* GAP is invite-only: the page is reached via the go link, never search. */}
      <meta name="robots" content="noindex, nofollow" />
    </SEO>
  );
}

function GrantsAndAssistancePage(props: PageProps) {
  const [submissionSuccess, setSubmissionSuccess] = useState(false);

  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="Stile's Grants and Assistance Program"
        subtitle="Apply for financial assistance"
        formHeading="Complete your application"
        formDescription=""
        childrenPlacement="above-image"
        submissionSuccess={submissionSuccess}
        formContent={
          <GapApplicationFormAu onSubmissionSuccess={() => setSubmissionSuccess(true)} />
        }
        successContent={
          <>
            <h6>Application received — thank you.</h6>
            <p>
              You and your school&apos;s Principal will be notified of the outcome via email after
              this round of applications closes.
            </p>
          </>
        }
        image={
          <StaticImage
            loading="eager"
            src="../../../stile-shared/assets/images/grants-and-assistance/hero.jpg"
            alt="Student using Stile X in the classroom"
          />
        }
      >
        <p>
          Complete this form to apply for Stile&apos;s Grants and Assistance Program. Before
          beginning your application, please{' '}
          <Link openInNewTab url={GAP_OVERVIEW_PDF}>
            read this document
          </Link>{' '}
          and have a letter of support from your Principal ready.
        </p>
      </ResourceAccessBlock>
    </PageLayout>
  );
}

export default GrantsAndAssistancePage;
